import { render, staticRenderFns } from "./InformacionPagoPerfil.vue?vue&type=template&id=378ced52"
import script from "./InformacionPagoPerfil.vue?vue&type=script&lang=js"
export * from "./InformacionPagoPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports